import { Button, YStack, SizableText, ImageField, Separator } from '@my/ui'
import { useImagePicker } from 'app/hooks'
import { ImagePickerAsset } from 'expo-image-picker'
import { GroupCreationHeader } from './group-creation-header'

export type GroupCreationFormImagesValues = {
  profileImage?: ImagePickerAsset | null
  coverImage: ImagePickerAsset | null
}

export interface GroupCreationFormImagesProps {
  error?: string
  defaultValues?: Partial<GroupCreationFormImagesValues>
  toastController: any // TODO: Add Props
  onSubmit: (values: GroupCreationFormImagesValues) => void
  onBack: () => void
}

export const GroupCreationFormImages = ({
  error,
  defaultValues,
  onSubmit,
  onBack,
  toastController,
  ...props
}: GroupCreationFormImagesProps) => {
  const { pickImage: pickProfileImage, image: profileImage } = useImagePicker({
    initialValue: defaultValues?.profileImage,
    onError: (err) =>
      toastController.show(err, {
        burntOptions: {
          preset: 'error',
        },
      }),
    constraints: {
      minWidth: 300,
      minHeight: 300,
    },
    resize: {
      width: 500,
    },
  })

  const { pickImage: pickCoverImage, image: coverImage } = useImagePicker({
    initialValue: defaultValues?.coverImage,
    onError: (err) =>
      toastController.show(err, {
        burntOptions: {
          preset: 'error',
        },
      }),
    resize: {
      width: 1600,
    },
    constraints: {
      minWidth: 800,
      minHeight: 450,
    },
    options: {
      aspect: [16, 9],
    },
  })

  const handleSubmit = () => {
    onSubmit({
      profileImage,
      coverImage,
    })
  }

  return (
    <YStack gap="$3.5" flex={1} w="100%" {...props}>
      <GroupCreationHeader title="Create Group" onBack={onBack}>
        <Button size="$3" theme="primary" onPress={handleSubmit}>
          Next
        </Button>
      </GroupCreationHeader>

      <Separator boc="$overlay8" w="100%" />

      <YStack gap="$3">
        <SizableText size="$4" fow="500">
          Add Profile photo (optional)
        </SizableText>
        <ImageField onPress={pickProfileImage} image={profileImage?.uri} />
      </YStack>

      <YStack gap="$3">
        <SizableText size="$4" fow="500">
          Add Cover photo (optional)
        </SizableText>
        <ImageField w="100%" h={200} onPress={pickCoverImage} image={coverImage?.uri} />
      </YStack>
    </YStack>
  )
}
